import { Row, Col, Image, Accordion, Container } from 'react-bootstrap';
import { useEffect } from 'react';
import hero from './images/sjmcmt-hero001.png';
import stevie from './images/IMG_9144.webp';
import './index.css';

function App() {

   useEffect(() => {
    const sections = document.querySelectorAll('.fade-section');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);
  
  return (
    <div className="App">
      <header>
        <Row className="header-row">
          <Image src={hero} className="hero" alt="Massage therapy hero banner" />
        </Row>
      </header>

      <main>
        <section className="cyan-row">
          <div className='fade-section'>
          <Container>
            <Row className="text-center">
              <h1 className="heading">About</h1>
            </Row>

            <Row>
              <Col xs={12} md={6} className="d-flex justify-content-end">
                <Image src={stevie} className="stevie" alt="Stevie Miller" />
              </Col>

              <Col xs={12} md={6} className="about-col">
                <p className="intro">Hi, my name is Stevie.</p>

                <p>
                  I was born and raised in Carlsbad, and I&apos;ve been practicing
                  massage therapy professionally for over a decade.
                </p>

                <p>
                  I graduated from the National Holistic Institute&apos;s 720-hour
                  Massage Therapy and Health Education program in San Francisco,
                  California, in 2010.
                </p>

                <p>
                  Since then, I have worked in almost every possible massage setting,
                  including hotels, massage chains, small studios, full-service day
                  spas, and a luxury 5-star resort.
                </p>

                <p>
                  Of all the settings in which I&apos;ve practiced, in-home mobile
                  massage is hands-down my favorite. What better place to relax and
                  unwind than in the comfort of your own home?
                </p>

                <p>
                  When I&apos;m not doing massage, you can catch me cooking a great
                  meal, hiking in Ruidoso, or snuggling with my cat, Galaxy.
                </p>
              </Col>
            </Row>
          </Container>
          </div>
        </section>

        <section className="services">
                    <div className='fade-section'>

          <Container>
            <Row className="text-center">
              <h1 className="heading">Services</h1>
            </Row>

            <Row>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Relax</Accordion.Header>
                  <Accordion.Body>
                    A 60-minute relaxing massage using long, flowing, Swedish-style
                    strokes. Ideal for those seeking to relieve stress, soothe
                    general aches and pains, ease fatigue, improve sleep, and reduce
                    blood pressure.
                    <br />
                    <br />
                    <strong>$95.00</strong>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>Rejuvenate</Accordion.Header>
                  <Accordion.Body>
                    A 90-minute therapeutic massage utilizing a combination of
                    Swedish-style and Deep Tissue techniques. Ideal for those seeking
                    pain relief, improved posture and mobility, and injury
                    rehabilitation in one focus area.
                    <br />
                    <br />
                    <strong>$135.00</strong>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Restore</Accordion.Header>
                  <Accordion.Body>
                    A 120-minute relaxing and therapeutic massage. This 2-hour deep
                    dive is ideal for those seeking a full-body reset and utilizes a
                    unique combination of techniques to create a deeply relaxing
                    service that addresses multiple focus areas.
                    <br />
                    <br />
                    <strong>$175.00</strong>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Row>
          </Container>
          </div>
        </section>

        <section className="booking">
                    <div className='fade-section'>

          <Container>
            <Row className="text-center">
              <h1 className="heading">Booking</h1>
            </Row>

            <Row className="text-center">
              <p>In-home Mobile Massage Services</p>

              <p>
                <strong>Hours:</strong>
                <br />
                10am - 6pm
                <br />
                Saturday and Sunday
                <br />
                by appointment only
              </p>

              <p>
                Email me at <strong>steviemillercmt@gmail.com</strong> or send a text to <strong>(575) 236-4475</strong> to book an
                appointment or ask any questions you may have about my services.
              </p>

              <p>This is the fastest and easiest way to get in touch with me.</p>

              <p>I look forward to hearing from you!</p>
            </Row>
          </Container>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>Stevie Miller, Certified Massage Therapist.</p>
      </footer>
    </div>
  );
}

export default App;